import { Component, OnInit } from "@angular/core";
import { ProfileService } from "../profile/profile.service";
import { Profile, ApiAccess } from "../models/profile.model";
import { NotificationBuilder } from "../shared/notificationBuilder";
import { HelperService } from "../services/helper.service";
import { AuthenticationService } from "../authentication/authentication.service";

@Component({
  selector: "app-setup-tutorial",
  templateUrl: "./setup-tutorial.component.html",
  styleUrls: ["./setup-tutorial.component.css"],
})
export class SetupTutorialComponent implements OnInit {
  profile: Profile;
  accountApiToken: string;
  apiAccess: ApiAccess;
  companyId: string;
  script: string = "";
  public isAdmin: boolean;
  loading: boolean = false;
  loadingMessage: string = "Conectando com a API. Isso pode demorar um pouco!";
  constructor(
    private profileService: ProfileService,
    private helperService: HelperService,
    private notificationBuilder: NotificationBuilder,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    debugger
    this.isAdmin = localStorage.getItem("admin-token") != null;
    this.profileService.getCurrentUserInfo().subscribe((data) => {
      debugger;
      this.profile = data;
      this.companyId = this.authenticationService.getCompanySelected()
      this.accountApiToken = this.authenticationService.getAccountApiToken();
      this.profileService.getApiAccess().subscribe((model) => {
        if (model.success) {
          this.apiAccess = model.data;
        }
      });
      this.script = this.helperService.getScript(this.profile);
    });
  }

  copyToClipboard() {
    let script = document.getElementById("scriptHelper") as HTMLInputElement;
    script.value = "";
    script.value = this.script;
    script.select();

    document.execCommand("Copy");
    this.notificationBuilder.showNotification(
      "success",
      1000,
      "O script foi copiado no seu clipboard"
    );
  }


  saveApiAccess() {
    debugger
    this.loading = true
    this.profileService.updateApiAccess(this.apiAccess).subscribe(data => {
      this.loading = false
      if (data != null) {
        this.notificationBuilder.showNotification('success', 7000, 'Chave de API salva... vamos verificar a validade em breve.')
      } else {
        this.notificationBuilder.showNotification('danger', 2000, data.error)
      }

    })
  }
}
